import { render, staticRenderFns } from "./SettingsExternalPos.vue?vue&type=template&id=7a45f164&scoped=true"
import script from "./SettingsExternalPos.vue?vue&type=script&lang=js"
export * from "./SettingsExternalPos.vue?vue&type=script&lang=js"
import style0 from "./SettingsExternalPos.vue?vue&type=style&index=0&id=7a45f164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a45f164",
  null
  
)

export default component.exports